import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campaign, Campaigns, CampaignsState } from 'Interfaces/Admin';

const INITIAL_STATE: CampaignsState = {
  loaded: false,
  collection: [],
};

const adminCampaignsSlice = createSlice({
  name: 'adminCampaigns',
  initialState: INITIAL_STATE,
  reducers: {
    loadedCampaigns(state, action: PayloadAction<Campaigns>) {
      return { loaded: true, collection: action.payload };
    },
    upsertCampaign(state, action: PayloadAction<Campaign>) {
      const campaign = action.payload;
      const index = state.collection.findIndex((c) => c.id === campaign.id);
      if (index === -1) {
        state.collection.push(campaign);
      } else {
        state.collection[index] = { ...state.collection[index], ...campaign };
      }
    },
  },
});

export const { loadedCampaigns, upsertCampaign } = adminCampaignsSlice.actions;

export default adminCampaignsSlice.reducer;
